import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { AttendanceStatusOptions, CustomSelect, FilterOptions } from "../../../../../../../../_helpers/Helpers";
import { useStudentsUIContext } from "../StudentsUIContext";

const prepareFilter = (queryParams, values) => {
  let { studentName, studentNumber, parentName, parentPhone, attendanceStatus } = values;
  studentNumber = studentNumber === "" ? null : studentNumber;
  const date = queryParams.filter.date;
  const sectionId = queryParams.filter.sectionId;
  const courseHour = queryParams.filter.courseHour;
  const newQueryParams = { ...queryParams };
  const filter = { date, sectionId, courseHour, studentName, studentNumber, parentName, parentPhone, attendanceStatus };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function StudentsFilter() {
  // Students UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      setQueryParams: studentsUIContext.setQueryParams,
      queryParams: studentsUIContext.queryParams,
    };
  }, [studentsUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(studentsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, studentsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      studentsUIProps.setQueryParams(newQueryParams);
    }
  };

  const attendanceStatusOptions = FilterOptions.concat(AttendanceStatusOptions.slice(1));

  return (
    <Formik
      initialValues={{
        studentName: "",
        studentNumber: "",
        parentName: "",
        parentPhone: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="studentNumber"
                min={1}
                placeholder="Öğrenci Numarası"
                onBlur={handleBlur}
                value={values.studentNumber}
                onChange={(e) => {
                  setFieldValue("studentNumber", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğrenci Numarası</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="studentName"
                placeholder="Adı Soyadı"
                onBlur={handleBlur}
                value={values.studentName}
                onChange={(e) => {
                  setFieldValue("studentName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="parentName"
                placeholder="Veli Adı Soyadı"
                onBlur={handleBlur}
                value={values.parentName}
                onChange={(e) => {
                  setFieldValue("parentName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Veli Adı Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="parentPhone"
                placeholder="Veli Telefonu"
                onBlur={handleBlur}
                value={values.parentPhone}
                onChange={(e) => {
                  setFieldValue("parentPhone", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Veli Telefonu</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={attendanceStatusOptions}
                value={values.attendanceStatus}
                placeholder="Yoklama Durumu"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("attendanceStatus", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Yoklama Durumu</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}